import { render, staticRenderFns } from "./serviceAnalysis.vue?vue&type=template&id=1122b689&scoped=true"
import script from "./serviceAnalysis.vue?vue&type=script&lang=js"
export * from "./serviceAnalysis.vue?vue&type=script&lang=js"
import style0 from "./serviceAnalysis.vue?vue&type=style&index=0&id=1122b689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122b689",
  null
  
)

export default component.exports